import { ComponentProps, FunctionComponent } from "react";
import {
  BiospecimenIcon,
  DataOverview,
  GenomicsIcon,
  TissueSampleIcon,
  LocationIcon,
  CancerIcon,
} from "~/assets/icons";

enum Report {
  OVERVIEW = "overview",
  BIOSPECIMEN = "biospecimen",
  TISSUE = "tissue",
  BLOOD = "blood",
  GENOMICS = "genomics",
  GEOSPATIAL = "geospatial",
  BREAST_CANCER = "breast-cancer",
}

interface ReportDisplay {
  ids: string[];
  label: string;
  description: string;
  icon: FunctionComponent<ComponentProps<"svg">>;
  iconColor: string;
}

export const DISPLAY_REPORT: Record<Report, ReportDisplay> = {
  [Report.OVERVIEW]: {
    ids: [
      "Overview-Report-2z3oTQpFRxQ9Uv6XbEpwJJ", // IU
      "Overview-Report-12tSRUxf6QMjDW7Ldak26U/page/snJelUA8R4", // IU
    ],
    label: "Overview",
    description: "Start here to get an overview of data in the platform",
    icon: DataOverview,
    iconColor: "#2225F5",
  },
  [Report.BIOSPECIMEN]: {
    ids: [
      "Biospecimen-Report-7ivfa44hsPvWNK50ZAM0oz", // IU
      "Biospecimen-Report-5CSvFvHkLPi8vZjmMbUAD8", // IU
    ],
    label: "Biospecimen Availability",
    description: "Overview of available specimens",
    icon: BiospecimenIcon,
    iconColor: "#E14B4B",
  },
  [Report.TISSUE]: {
    ids: [],
    label: "Tissue and Bone Marrow Availability",
    description: "Overview of solid specimens",
    icon: TissueSampleIcon,
    iconColor: "#FF4C1A",
  },
  [Report.BLOOD]: {
    ids: [],
    label: "Blood Availability",
    description: "Overview of blood specimens",
    icon: BiospecimenIcon,
    iconColor: "#E14B4B",
  },
  [Report.GENOMICS]: {
    ids: [
      "Genomics-Report-1Q2Lz0rQH0OuL09MpGuWwG/page/ApZslS2VUx", // IU
      "Genomics-Report-DKS1yk3P4skfICdC0VcZe/page/Ofwyqr_K-H", // IU
    ],
    label: "Genomics",
    description: "Overview of genomics sequencing files and indexed variants",
    icon: GenomicsIcon,
    iconColor: "#651EFE",
  },
  [Report.GEOSPATIAL]: {
    ids: [],
    label: "Geospatial",
    description: "Visualize population on a map",
    icon: LocationIcon,
    iconColor: "#008CF2",
  },
  [Report.BREAST_CANCER]: {
    ids: [],
    label: "Breast Cancer",
    description: "Deep dive into breast cancer cases",
    icon: CancerIcon,
    iconColor: "#DD37F8",
  },
};

export default Report;
